import * as React from "react";
const SvgFiRrTransformerBolt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 22h-1V6h1a1 1 0 0 0 0-2h-1v-.5A1.5 1.5 0 0 0 19.5 2H19V1a1 1 0 0 0-2 0v1h-.5A1.5 1.5 0 0 0 15 3.5V4H9v-.5A1.5 1.5 0 0 0 7.5 2H7V1a1 1 0 0 0-2 0v1h-.5A1.5 1.5 0 0 0 3 3.5V4H2a1 1 0 0 0 0 2h1v16H2a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2M5 6h14v16H5zm10.309 7.846c.28.521.25 1.151-.077 1.645l-2.37 4.018a1 1 0 1 1-1.722-1.017L13.202 15h-3.085a1.62 1.62 0 0 1-1.297-.653 1.62 1.62 0 0 1-.249-1.43c.021-.07 2.454-4.408 2.454-4.408a1 1 0 1 1 1.743.981l-1.976 3.509h3.104c.592 0 1.133.325 1.413.847"
    />
  </svg>
);
export default SvgFiRrTransformerBolt;
